import { Promotion } from '../../../../stores/promotion';
import {
    getPromotionStatus,
    PromotionStatusTag,
} from '../../../../utils/promotion-status';

const renderTemporalStatus = (_: unknown, record: Promotion) => {
    const status = getPromotionStatus(record);
    return <PromotionStatusTag status={status} />;
};

export default renderTemporalStatus;
